module.exports = __webpack_public_path__ + "img/Hover_Cash_Management.30262601.png";